import React from 'react';

export const DetailSpeciesText = ({ down_type, t }) => {
  let speciesActiveTitle;
  let speciesActiveValue;

  if (down_type.includes('Goose')) {
    speciesActiveTitle = "Anser Anser f. Domestica";
  } else if (down_type.includes('Eider')) {
    speciesActiveTitle = "Somateria mollissima";
  } else if (down_type.includes('Muscovy')) {
    speciesActiveTitle = "Cairina moschata";
  } else {
    speciesActiveTitle = "Anas Bochas Domestica";
  }

  // Use the 't' function for language-specific values
  switch (down_type) {
    case "White Goose":
      speciesActiveValue = t("species.whiteGoose");
      break;
    case "Muscovy White Duck":
      speciesActiveValue = t("species.muscovyWhiteDuck");
      break;
    case "White Duck":
      speciesActiveValue = t("species.whiteDuck");
      break;
    case "Grey Goose":
      speciesActiveValue = t("species.greyGoose");
      break;
    case "Muscovy Grey Duck":
      speciesActiveValue = t("species.muscovyGreyDuck");
      break;
    case "Grey Duck":
      speciesActiveValue = t("species.greyDuck");
      break;
    default:
      speciesActiveValue = down_type; // Fallback
      break;
  }

  return (
    <>
      <p className="spec-title">{speciesActiveTitle}</p>
      <p className="spec-value">{speciesActiveValue}</p>
    </>
  );
};